export const sheets_en = {
  crm_edit_contact: "Edit contact",
  create_row_above: "Create contact above",
  create_row_below: "Create contact below",
  crm_add_enrichment: "Add enrichment",
  crm_customize_view: "Customize view",
  text: "Text",
  number: "Number",
  filter_on_this_column: "Filter on this column",
  hide: "Hide",
  quick_action: "Quick Actions",
  crm_auto_sync: "Auto-sync",
  auto_sync_drawer_title: "Auto-sync settings",
  crm_segmented_filters: "Segment Filters",
  segmented_filters_drawer_title: "Segments",
  new_segmented_view: "New segment view",
  add_condition: "Add condition",
  sorts: "Sorts",
  add_sort: "Add sort",
  save_state_default: "Autosave",
  save_state_saved: "All changes saved",
  save_state_saving: "Saving changes…",
  save_state_not_saved: "Changes not saved",
  save_state_offline: "Offline",

  limited_selection_select_rows_from: "Select rows from",
  selected_count: "{count} selected",

  crm_column_visibility_dialog_title: "Customized View",
  crm_column_visibility_dialog_desc:
    "Choose the data fields you want to display in this table.",
  crm_column_visibility_dialog_tips:
    "Don’t see the property you’re looking for? ",
  crm_column_visibility_dialog_available_fields: "Available Fields",
  crm_column_visibility_dialog_no_fields_title: "No fields available",

  crm_column_visibility_dialog_no_fields_desc:
    "There are no additional fields to add right now. Try adding new properties or enrichment fields to expand your table options.",

  crm_column_visibility_dialog_fields_order:
    "Selected Fields (Drag to reorder)",

  sheets: "Sheets",
  sheets_description:
    "Manage your contacts and companies in one organized workspace.",

  crm_delete_column_warning_dialog_title: 'Delete Column "{name}"',
  crm_delete_column_warning_dialog_para1: "You’re about to delete this column.",
  crm_delete_column_warning_dialog_para2:
    "This action cannot be undone. Please confirm if you want to proceed with deleting this column.",

  crm_delete_row_warning_dialog_title: "Delete Record",
  crm_delete_row_warning_dialog_para1: "You’re about to delete this record.",
  crm_delete_row_warning_dialog_para2:
    "This action cannot be undone. Please confirm if you want to proceed with deleting this record.",
};
